import React from "react";
import Typography from "@material-ui/core/Typography";
const ProcurementReports = ({}) => {
  return (
    <React.Fragment>
      <Typography paragraph variant="h4">
        Procurement Reports
      </Typography>
      <Typography paragraph variant="h5">
        Explore dashboard and various reports of Procurement module
      </Typography>
      <Typography paragraph variant="body1">
        Procurement Reports is one of the features under the Procurement module
        to display various reports regarding the Procurement business process.
        It is used to analyze information, determine conclusions, and offer
        recommendations to solve problems.
      </Typography>
      <Typography paragraph variant="h5" className="mt-5">
        How it works
      </Typography>
      <Typography paragraph variant="body1">
        The first information displayed on this feature is the tabs indicating
        the various report types. The various reports under the Procurement
        module are listed below:
      </Typography>
      <Typography paragraph variant="body1">
        <b>Procurement Dashboard</b>
        <br />
        This is the main dashboard of the Procurement module. There is a lot of
        high-level information shown as a widget to give you the best insight
        regarding what happens in the Procurement business process. This best
        analytic information will help you a lot to make business decisions.
        Below are the available widgets inside this dashboard:
        <ul>
          <li>Purchases Widget</li>
          <li>Vendors Widget</li>
          <li>On-Time Supplies Widget</li>
          <li>Average Lead Time Widget</li>
          <li>Purchase Order Overview Widget</li>
          <li>Lead Time Analysis Widget</li>
          <li>Top 5 Vendors Widget</li>
          <li>Top 5 Purchase Items Widget</li>
          <li>Top 5 Spend Areas Widget</li>
          <li>Cost Savings Widget</li>
          <li>Vendor Average Performance Widget</li>
          <li>Purchase By Countries Widget</li>
        </ul>
      </Typography>
      <Typography paragraph variant="body1">
        <b>Purchase Overview</b>
        <br />
        This report tells you about every purchase by item purchased and its
        total purchase amount with a cost-saving analysis of each item.
      </Typography>
      <Typography paragraph variant="body1">
        <b>Vendor Analytics</b>
        <br />
        This report tells you about every purchase from vendor and its total
        purchase amount with a performance analysis of each vendor to fulfill
        the company's needs.
      </Typography>
      <Typography paragraph variant="body1">
        <b>Cost Control</b>
        <br />
        This report tells you about cost control analysis as the main guideline
        for the procurement team to determine the purchase price to get the best
        price.
      </Typography>
    </React.Fragment>
  );
};

export default ProcurementReports;
